//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
export default {
  name: 'form-item-wrapper',
  mixins: [i18n],
  props: {
    field: Object,
    designer: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designState: {
      type: Boolean,
      default: false
    },
    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */type: String,
      default: ''
    },
    rules: Array
  },
  inject: ['formConfig'],
  computed: {
    selected: function selected() {
      return !!this.designer && this.field.id === this.designer.selectedId;
    },
    label: function label() {
      if (!!this.field.options.labelHidden) {
        return '';
      }
      return this.field.options.label;
    },
    labelWidth: function labelWidth() {
      if (!!this.field.options.labelHidden) {
        return !!this.designState ? 5 : 0; //设计期间标签最小宽度5像素，以便于鼠标点击可选中组件！！
      }
      if (!!this.field.options.labelWidth) {
        return this.field.options.labelWidth;
      }
      if (!!this.designer) {
        return this.designer.formConfig.labelWidth;
      } else {
        return this.formConfig.labelWidth;
      }
    },
    labelAlign: function labelAlign() {
      if (!!this.field.options.labelAlign) {
        return this.field.options.labelAlign;
      }
      if (!!this.designer) {
        return this.designer.formConfig.labelAlign || 'label-left-align';
      } else {
        return this.formConfig.labelAlign || 'label-left-align';
      }
    },
    customClass: function customClass() {
      return !!this.field.options.customClass ? this.field.options.customClass.join(' ') : '';
    },
    subFormName: function subFormName() {
      return !!this.parentWidget ? this.parentWidget.options.name : '';
    },
    subFormItemFlag: function subFormItemFlag() {
      return !!this.parentWidget ? this.parentWidget.type === 'sub-form' : false;
    }
  },
  created: function created() {
    //
  },
  methods: {
    selectField: function selectField(field) {
      if (!!this.designer) {
        this.designer.setSelected(field);
        this.designer.emitEvent('field-selected', this.parentWidget); //发送选中组件的父组件对象
      }
    },
    selectParentWidget: function selectParentWidget() {
      if (this.parentWidget) {
        this.designer.setSelected(this.parentWidget);
      } else {
        this.designer.clearSelected();
      }
    },
    moveUpWidget: function moveUpWidget() {
      this.designer.moveUpWidget(this.parentList, this.indexOfParentList);
      this.designer.emitHistoryChange();
    },
    moveDownWidget: function moveDownWidget() {
      this.designer.moveDownWidget(this.parentList, this.indexOfParentList);
      this.designer.emitHistoryChange();
    },
    removeFieldWidget: function removeFieldWidget() {
      var _this = this;
      console.log('removeFieldWidget', this.designer.selectedWidgetName);
      if (!!this.parentList) {
        var fieldRefName = this.designer.selectedWidgetName;
        var nextSelected = null;
        if (this.parentList.length === 1) {
          if (!!this.parentWidget) {
            nextSelected = this.parentWidget;
          }
        } else if (this.parentList.length === 1 + this.indexOfParentList) {
          nextSelected = this.parentList[this.indexOfParentList - 1];
        } else {
          nextSelected = this.parentList[this.indexOfParentList + 1];
        }
        this.$nextTick(function () {
          // this.$store.commit('app/SET_FORM_INDEX_SET', this.designer.selectedWidget)

          _this.parentList.splice(_this.indexOfParentList, 1);
          _this.designer.setSelected(nextSelected);
          _this.designer.formWidget.deleteWidgetRef(fieldRefName); //删除组件ref！！！
          _this.designer.emitHistoryChange();
        });
      }
    },
    getPropName: function getPropName() {
      if (this.subFormItemFlag && !this.designState) {
        return this.subFormName + '.' + this.subFormRowIndex + '.' + this.field.options.name + '';
      } else {
        return this.field.options.name;
      }
    }
  }
};